<template>
  <div
    class="app-main-inner"
  >
    <div class="app-main-page" style="height: calc(100vh - 100px);align-items: stretch">
      <cargo-left-right-resize
        :left-style="{flex:'none','max-width':'50%', 'width': '20%'}"
        :right-style="{'overflow': 'hidden'}"
        style="min-height:100%"
      >
        <template slot="left" :style="{minWidth:'250px',border:'1px solid #ccc',height:'100%',width: '80%'}">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="officeDeptRoleTree.gridOptions"
            :column-defs="officeDeptRoleTree.columnDefs"
            :row-data="officeDeptRoleTree.rowData"
            style="width:100%;height: 100%"
            :class="isEdit?'not-click':''"
            @gridReady="onAgReady"
          />
        </template>

        <template slot="right" style="display:flex;flex-direction:column;flex:1;height:auto;border:1px solid #ccc;">
          <div>
            <div class="filters">
              <el-form :inline="true" label-width="60px" label-position="left" />
            </div>
            <div class="triggers" :style="{padding : currentType==='roleTab'?'5px':''}">
              <template v-if="currentType==='roleTab'">
                <template v-if="!isEdit">
                  <el-button type="primary" @click="isEdit=true">{{ $t('CargoMsg.Cargo_EditPermission') }}</el-button>
                  <el-button type="primary" @click="popNoCurrentRoleUser">{{ $t('CargoMsg.Cargo_AddUser') }}</el-button>
                  <el-button type="danger" @click="toDelUser">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                </template>
                <template v-else>
                  <el-button type="primary" @click="popNoRoleUser">{{ $t('CargoMsg.Cargo_AssignRolesToUsers') }}</el-button>
                  <el-button type="primary" @click="popScopeUser">{{ $t('CargoMsg.Cargo_SelectARangeOfUsers') }}</el-button>
                  <el-button type="danger" @click="isEdit=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
                </template>

                <el-button type="primary" @click="exportExcel">{{ $t('CargoMsg.Cargo_ExcelExport') }}</el-button>
              </template>
            </div>
          </div>
          <cargo-ag-grid
            :show-side-bar="false"
            :column-defs="userOfRoleGrid.columnDefs"
            :row-data="userOfRoleGrid.rowData"
            :grid-options="userOfRoleGrid.gridOptions"
            style="width: 100%;flex-grow:1;height: 95%"
            @gridReady="onReady"
          />
        </template>
      </cargo-left-right-resize>
    </div>
    <!--添加用户-->
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="userOfNoCurrentRoleGrid.isShow" :title="$t('SystemMaintenance.AddRoleUser')" width="800px;" @close="userOfNoCurrentRoleGrid.searchLikeName=''">
      <div class="app-main-inner-row" style="padding-bottom: 5px;">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_Search')">
                <el-input v-model="userOfNoCurrentRoleGrid.searchLikeName" style="width: 260px" size="mini" placeholder="" @input="toFilterNoCurrentRoleUser" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid-dialog">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="userOfNoCurrentRoleGrid.gridOptions"
          :column-defs="userOfNoCurrentRoleGrid.columnDefs"
          :row-data="userOfNoCurrentRoleGrid.rowData"
          style="width:100%;"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="toSaveNoCurrentRoleUser">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" @click="userOfNoCurrentRoleGrid.isShow=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--选择没有角色的用户-->
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="userOfNoRoleGrid.isShow" :title="$t('SystemMaintenance.AddUserWithUnassignedRole')" width="800px;" @close="userOfNoRoleGrid.searchLikeName=''">
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('SystemMaintenance.Query')">
                <el-input v-model="userOfNoRoleGrid.searchLikeName" style="width: 260px" size="mini" placeholder="" @input="toFilterNoRoleUser" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid-dialog">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="userOfNoRoleGrid.gridOptions"
          :column-defs="userOfNoRoleGrid.columnDefs"
          :row-data="userOfNoRoleGrid.rowData"
          style="width:100%;"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="toSaveNoRoleUser">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" @click="userOfNoRoleGrid.isShow=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
    <!--选择范围-->
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="officeDeptTree.isShow" :title="$t('SystemMaintenance.SelectDepartment')" width="800px;">
      <div class="app-main-inner-row row-grid-dialog">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="officeDeptTree.gridOptions"
          :column-defs="officeDeptTree.columnDefs"
          :row-data="officeDeptTree.rowData"
          style="width:100%;min-height: 500px"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="toSaveScopeUser">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" @click="officeDeptTree.isShow=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getOfficeDeptTree } from '@/api/office'
import { getUserList4NoRole, getUserListForRole, addUser2Role, getUserListByRoleUuid, delUser2Role } from '@/api/user'
import { getGridSelectedIds } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { exportExcel } from '@/utils/tableDataExportUtils'
import ColumnUtils from '@/utils/ColumnUtils'
export default {
  name: 'UserRoleManage',
  components: {
    cargoLeftRightResize
  },
  data() {
    return {
      loading: null,
      isEdit: false,
      currentRole: {},
      currentType: 'officeTab',
      officeDeptRoleTree: {
        columnDefs: [],
        rowData: [],
        gridOptions: {}
      },
      officeDeptRoleTreeGridApi: null,
      officeDeptTree: { // 公司部门树，不含角色
        currentScope: {},
        isShow: false,
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        gridOptions: {}
      },
      userOfNoRoleGrid: { // 未分配角色用户
        isShow: false,
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        gridOptions: {}
      },
      userOfNoCurrentRoleGrid: { // 未分配当前角色用户
        isShow: false,
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        initRowData: [],
        gridOptions: {}
      },
      userOfRoleGrid: { // 拥有该角色的用户
        isShow: false,
        initRowData: [],
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        gridOptions: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false }
      }
    }
  },
  beforeMount() {
    this.initData()
  },
  mounted() {
    this.fetchOfficeDeptRoleTree()
  },
  methods: {
    onReady(params) {
    },
    onAgReady(params) {
      this.officeDeptRoleTreeGridApi = params.api
    },
    onScopeUserTreeClick(event) {
      console.log(' onScopeUserTreeClick event', event)
      this.officeDeptTree.currentScope = { ...event.node.data }
    },
    onRowClick(event) {
      this.isEdit = false
      this.currentRole = {}
      console.log('event.node.data', event.node.data)
      if (event.node.data.type === 1) {
        // 公司
        this.currentType = 'officeTab'
        this.userOfRoleGrid.rowData = []
      } else if (event.node.data.type === 2) {
        // 部门
        this.currentType = 'deptTab'
        this.userOfRoleGrid.rowData = []
      } else if (event.node.data.type === 3) {
        // 角色
        this.currentType = 'roleTab'
        this.currentRole = { ...event.node.data }
        // todo 获取 角色用户list
        this.getUserListByRole()
      }
    },
    getUserListByRole() {
      getUserListByRoleUuid(this.currentRole.uuid).then(res => {
        const userList = []
        for (const data of res.data) {
          const index = userList.findIndex(p => p.uuid === data.uuid)
          if (index <= 0) {
            userList.push(data)
          }
        }
        this.userOfRoleGrid.rowData = userList
      })
    },
    fetchOfficeDeptRoleTree() {
      this.loading = getLoading()

      getOfficeDeptTree().then(res => {
        this.officeDeptRoleTree.rowData = [...res.data]
        this.officeDeptTree.rowData = res.data.filter(item => {
          return item.type === 1 || item.type === 2
        })
      }).finally(() => {
        this.loading.close()
      })
    },
    async toDelUser() {
      const userUuids = await getGridSelectedIds(this.userOfRoleGrid.gridOptions, 'uuid')
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete3'), this.$t('Message.ConfirmDelete'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }
      ).then(() => {
        const users = userUuids.map(uuid => {
          return { uuid }
        })
        this.loading = getLoading()
        delUser2Role({ uuid: this.currentRole.uuid, users }).then(res => {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.getUserListByRole()
        }).finally((e) => {
          this.loading.close()
        })
      }).catch(() => { })
    },
    toFilterNoCurrentRoleUser() {
      this.userOfNoCurrentRoleGrid.rowData = this.getFilterUser(this.userOfNoCurrentRoleGrid.initRowData, this.userOfNoCurrentRoleGrid.searchLikeName)
      if (!this.userOfNoCurrentRoleGrid.searchLikeName) {
        this.userOfNoCurrentRoleGrid.rowData = this.userOfNoCurrentRoleGrid.initRowData
      } else {
        this.userOfNoCurrentRoleGrid.rowData = []
        for (const user of this.userOfNoCurrentRoleGrid.initRowData) {
          const chineseName = user.chineseName ? user.chineseName.toLowerCase() : ''
          const englishName = user.englishName ? user.englishName.toLowerCase() : ''
          const email = user.email ? user.email.toLowerCase() : ''
          if (chineseName.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1 || englishName.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1 || email.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1) {
            this.userOfNoCurrentRoleGrid.rowData.push(user)
          }
        }
      }
    },
    toFilterNoRoleUser() {
      this.userOfNoRoleGrid.rowData = this.getFilterUser(this.userOfNoRoleGrid.initRowData, this.userOfNoRoleGrid.searchLikeName)
    },
    getFilterUser(rowData, value) {
      return rowData.filter(item => {
        if (value && item.chineseName) {
          return item.chineseName.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
      })
    },
    popNoCurrentRoleUser() {
      // 没当前角色的用户弹框
      // 获取租户下全部用户
      this.userOfNoCurrentRoleGrid.isShow = true
      this.loading = getLoading()
      getUserListForRole({ pageSize: 10000 }).then(res => {
        this.userOfNoCurrentRoleGrid.rowData = res.data
        this.userOfNoCurrentRoleGrid.initRowData = res.data
      }).finally((e) => {
        this.loading.close()
      })
    },
    popNoRoleUser() {
      // 没角色的用户弹框
      getUserList4NoRole().then(res => {
        this.userOfNoRoleGrid.rowData = res.data
        this.userOfNoRoleGrid.initRowData = res.data
      })
      this.userOfNoRoleGrid.isShow = true
    },
    popScopeUser() {
      // 根据选择的范围弹框
      this.officeDeptTree.rowData = this.officeDeptRoleTree.rowData.filter(item => {
        return item.type === 1 || item.type === 2
      })
      this.officeDeptTree.isShow = true
    },
    async toSaveNoCurrentRoleUser() {
      // 保存没当前角色的用户 并刷新
      const userUuids = await getGridSelectedIds(this.userOfNoCurrentRoleGrid.gridOptions, 'uuid')
      for (const data of this.userOfRoleGrid.rowData) {
        if (userUuids.includes(data.uuid)) {
          this.$message.warning(this.$t('SystemMaintenance.SelectedUsersAlreadyExist'))
          return
        }
      }
      this.loading = getLoading()
      const users = userUuids.map(uuid => {
        return { uuid }
      })
      await this.toSaveUser({ uuid: this.currentRole.uuid, users }).catch(e => {
        this.loading.close()
      })
      this.loading.close()
      this.userOfNoCurrentRoleGrid.isShow = false
    },
    async toSaveNoRoleUser() {
      // 保存没角色的用户
      // 保存没当前角色的用户 并刷新
      const userUuids = await getGridSelectedIds(this.userOfNoRoleGrid.gridOptions, 'uuid')
      const users = userUuids.map(uuid => {
        return { uuid }
      })
      await this.toSaveUser({ uuid: this.currentRole.uuid, users })
      this.userOfNoRoleGrid.isShow = false
    },
    async toSaveScopeUser() {
      // 根据选择的范围保存用户
      // 保存没当前角色的用户 并刷新
      this.loading = getLoading()
      let type = 'office'
      let department
      let officeUuid
      if (this.officeDeptTree.currentScope.type === 2) {
        type = 'dept'
        department = this.officeDeptTree.currentScope.uuid
      } else {
        officeUuid = this.officeDeptTree.currentScope.uuid
      }
      await this.toSaveUser({ uuid: this.currentRole.uuid, department, officeUuid }, type).finally((e) => {
        this.loading.close()
      })
      this.officeDeptTree.isShow = false
    },
    toSaveUser(data, type) {
      return addUser2Role(data, type).then(res => {
        this.$message.success(this.$t('SystemMaintenance.AddSuccessfully'))
        this.getUserListByRole()
        return Promise.resolve()
      })
    },
    exportExcel() {
      if (this.userOfRoleGrid.rowData && this.userOfRoleGrid.rowData.length > 0) {
        const columnDefs = []
        this.userOfRoleGrid.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
        const name = this.currentRole.chineseName + this.$moment(new Date()).format('yyyyMMDDHHmmss')
        exportExcel(name, this.userOfRoleGrid.rowData, columnDefs)
      }
    },
    initData() {
      // 左侧的公司角色树
      this.officeDeptRoleTree.columnDefs = [
        {
          headerName: 'Path',
          field: 'path',
          width: 80,
          hide: true
        }
      ]
      this.officeDeptRoleTree.gridOptions = {
        rowSelection: 'multiple',
        groupDefaultExpanded: 1,
        suppressRowClickSelection: true,
        treeData: true,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          width: 300,
          tooltipValueGetter: (params) => {
            return params.data.chineseName
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: (params) => {
              if (params.data.type === 1) {
                return '[' + params.data.code + ']' + params.data.chineseName
              }
              const iconName = params.data.type !== 3 ? '' : 'grid-icon-disabled'
              const color = params.data.type !== 3 ? '#' : '#e6a23c'
              return params.data.type === 3 ? `<svg class="svg-icon" fill="${color}" aria-hidden="true" style="height:1.1em;width:1.1em;">
                <use xlink:href="#icon-${iconName}"></use>
              </svg>${params.data.chineseName}` : params.data.chineseName
            },
            checkbox: false
          }
        },
        onRowClicked: this.onRowClick
      }
      // 用户选择范围的 公司部门树
      this.officeDeptTree.columnDefs = [
        {
          headerName: 'Path',
          field: 'path',
          width: 80,
          hide: true
        }
      ]
      this.officeDeptTree.gridOptions = {
        rowSelection: 'multiple',
        groupDefaultExpanded: 1,
        suppressRowClickSelection: true,
        treeData: true,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          width: 600,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: (params) => {
              if (params.data.type === 1) {
                return '[' + params.data.code + ']' + params.data.chineseName
              }
              return params.data.chineseName
            },
            checkbox: false
          }
        },
        onRowClicked: this.onScopeUserTreeClick
      }

      // 拥有该角色的用户
      this.userOfRoleGrid.columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'chineseName',
          width: 240
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ValidOrNot'),
          field: 'active',
          width: 100,
          valueGetter: (params) => {
            if (params.data.active) {
              return this.$t('SystemMaintenance.Valid')
            } else {
              return this.$t('SystemMaintenance.Invalid')
            }
          }
        }]
      this.userOfRoleGrid.gridOptions = {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        defaultColDef: {
          resizable: true,
          filter: true
        }
      }
      // 没被分配角色的用户
      this.userOfNoRoleGrid.columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'chineseName',
          width: 240
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 100
        }]
      this.userOfNoRoleGrid.gridOptions = {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        }
      }
      // 没被分配当前角色的用户
      this.userOfNoCurrentRoleGrid.columnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LoginName'),
          field: 'login',
          width: 240
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
          field: 'chineseName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
          field: 'englishName',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_email'),
          field: 'email',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Tel'),
          field: 'phone',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Fax'),
          field: 'fax',
          width: 100
        }]
      this.userOfNoCurrentRoleGrid.gridOptions = {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
